// extracted by mini-css-extract-plugin
module.exports = {"cardWrapperSmall":"Categories_cardWrapperSmall__wSRSI"};